import { useEffect, useState } from 'react';
import { useManagedSearchParam } from '@shared/hooks/useManagedSearchParam';
import { useTranslation } from '@shared/core';
import { useToast } from '@withjoy/joykit';
import { EMAIL_VERIFICATION_SUCCESS_PARAM_VALUE } from '@shared/components/AccountRedirect/AccountRedirect';
import { useFullPageLoaderContext } from '@shared/components/JoyLogoLoader/FullPageLoaderProvider';

export const useEmailVerificationSuccessNotifier = () => {
  const [showSuccessEffect, setShowSuccessEffect] = useState(false);

  const [emailVerificationSuccessParamValue, setEmailVerificationSuccessParamValue] = useManagedSearchParam(EMAIL_VERIFICATION_SUCCESS_PARAM_VALUE);
  const { isAnimationCompletelyStopped } = useFullPageLoaderContext();

  const { toast } = useToast();
  const { t } = useTranslation('joykit');

  useEffect(() => {
    if (emailVerificationSuccessParamValue && isAnimationCompletelyStopped) {
      toast(t('emailVerificationSuccess')());
      setEmailVerificationSuccessParamValue(null);
      setShowSuccessEffect(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailVerificationSuccessParamValue, isAnimationCompletelyStopped]);

  return {
    showSuccessEffect,
  };
};
